import {InjectionToken} from "@angular/core";

export const WEBABO_SERVICE_URL = new InjectionToken<string>('webaboServiceUrl');
